import styled from 'styled-components';

import colors from '@utils/colors';
import fonts, { weights } from '@utils/fonts';
import { mq } from '@utils/responsive';
import { fontStyles, Heading } from '@components/type';

export const Wrapper = styled.section``;

export const Layout = styled.div`
  width: 100%;
  max-width: 990px;
  margin: 0 auto;

  ${(props) => props.$layout === 'row' && mq.gtlg`
    max-width: 1280px;
  `}
`;

export const SectionHeading = styled(Heading)`
  margin-bottom: 32px;
  color: ${colors.B500};
  text-transform: uppercase;

  ${mq.gtmd`
    margin-bottom: 48px;
  `}
`;

export const Circles = styled.div`
  --circle-gap: 16px;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--circle-gap);
  max-width: 880px;
  margin: 0 auto;

  ${mq.gtsm`
    --circle-gap: 24px;

    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  `}

  ${mq.gtmd`
    --circle-gap: 32px;
  `}

  ${(props) => props.$layout === 'row' && mq.gtlg`
    --circle-gap: 16px;

    max-width: none;
  `}
`;

export const Circle = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  max-width: 400px;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  background-color: ${(props) => props.$background};

  ${mq.gtsm`
    width: calc(50% - var(--circle-gap) / 2);
    max-width: none;
  `}

  ${(props) => props.$layout === 'row' && mq.gtlg`
    flex: 1 1 0;
    width: auto;
    min-width: 0;
    max-width: calc(50% - var(--circle-gap) / 2);
  `}
`;

export const CircleContent = styled.div`
  width: 72%;
  margin-top: 20%;
  text-align: center;
`;

export const CircleHeading = styled.h3`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  min-height: 2.1em;
  color: ${colors.N0};
  margin: 0 0 12px;
  font-family: ${(props) => fonts(props.theme.locale).SANS_CONDENSED};
  font-size: 24px;
  font-weight: ${weights.BOLD};
  letter-spacing: 0.02em;
  line-height: 1.05;
  text-transform: uppercase;

  ${mq.gtsm`
    font-size: 26px;
  `}

  ${mq.gtmd`
    margin: 0 auto 16px;
    max-width: 70%;
    font-size: 40px;
  `}

  ${(props) => props.$layout === 'row' && mq.gtlg`
    margin-bottom: 12px;
    font-size: 30px;
  `}
`;

export const CircleText = styled.div`
  display: inline-block;
  color: ${colors.B600};
  font-family: ${(props) => fonts(props.theme.locale).SANS};
  font-size: 15px;
  font-weight: ${weights.BOLD};
  line-height: 1.3;
  text-align: left;

  ${mq.gtsm`
    font-size: 13px;
  `}

  ${mq.gtmd`
    font-size: 18px;
  `}

  ${(props) => props.$layout === 'row' && mq.gtlg`
    font-size: 15px;
  `}

  p {
    margin: 0;
    text-align: center;
  }

  p + p,
  p + ul,
  ul + p {
    margin-top: 0.5em;
  }

  em {
    ${fontStyles.em};
  }

  strong {
    ${fontStyles.strong};
  }

  ul {
    margin: 0;
    padding: 0 0 0 1.2em;
    list-style-type: disc;
  }

  li {
    margin-bottom: 0.25em;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
